import { efficiencyYBIValidate } from "../../application/dtos/efficiency_ybi_validate";

export class efficiencyYBIEntity {
    constructor( data ){ // cuando se recive un objeto con propiedades indefinidas en vez de las propiedades definidad de un objeto
        this.data = data
    }

    isValid() {
        return efficiencyYBIValidate(this);
    }
}